import { render, staticRenderFns } from "./company-address-card.vue?vue&type=template&id=551b3c10&scoped=true&"
import script from "./company-address-card.vue?vue&type=script&lang=js&"
export * from "./company-address-card.vue?vue&type=script&lang=js&"
import style0 from "./company-address-card.vue?vue&type=style&index=0&id=551b3c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b3c10",
  null
  
)

export default component.exports